(function() {
    /* jshint validthis: true */
    "use strict";
    
    var lang = lang || document.documentElement.lang;
    var langs = langs || document.documentElement.getAttribute("langs");
    var blockedDates = '';
    var form;

    function addBlockedDate() {
        var day = $('input[name=blockedDateDay]').val();
        var month = parseInt($('input[name=blockedDateMonth]').val()) + 1;
        var year = $('input[name=blockedDateYear]').val();

        if(day && month && year) {

            if(String(day).length == 1) {
                day = "0" + day;
            }

            if(String(month).length == 1) {
                month = "0" + month;
            }
            var dateString = (day+'/'+month+'/'+year).toString();

            if (!(blockedDates.includes(dateString))) {
                if (blockedDates) {
                    blockedDates += ',' + dateString;
                }
                else {
                    blockedDates = dateString;
                }
                updateLabelLangs('admin-blocked-dates', blockedDates, langs, addRow(dateString), true);
            }
            else {
                alert('Date already blocked');
            }
        }
        else {
            alert('Please pick a date');
        }
    }

    function removeBlockedDate() {
        var t = $(this);
        var row = $(t).closest('.admin-dates-table-row');
        var date = row.data('date');
        
        if ((blockedDates.includes(','+date))) {
            blockedDates = blockedDates.replace(','+date, "");

            updateLabelLangs('admin-blocked-dates', blockedDates, langs, $(row).remove(), true);
        }
        else if((blockedDates.includes(date+','))) {
            blockedDates = blockedDates.replace(date+',', "");

            updateLabelLangs('admin-blocked-dates', blockedDates, langs, $(row).remove(), true);
        }

        else {
            blockedDates = blockedDates.replace(date, "");

            updateLabelLangs('admin-blocked-dates', blockedDates, langs, $(row).remove(), true);
        }
    }

    function addRow(d) {
        var clone = $('.admin-dates-table-row.clone').clone(true);
        clone.removeClass('clone');
        clone.data('date', d);
        $('.table-item-text', clone).text((d).toString());
        clone.appendTo('.admin-dates-table');
    }
    
    // Initiate
    DOMInit("complete", function(e) {
        form = $('.admin-dates-form');
        blockedDates = form.data('dates');

        $('.admin-date-select-btn').on('click', addBlockedDate);
        $('.admin-date-delete-btn').on('click', removeBlockedDate);
    });

})();